<fe-empty-container
    [containerClasses]="'mb-25'"
    [containerGutter]="'gx-5 gx-md-18'"
>
    <div class="row">
        <div class="col-12 gy-19">
            <span class="fe-empty-container-title fw-bold">{{
                'fe_precheckin_active_reservation_active_reservation_card_title'
                    | translate
            }}</span>
        </div>
    </div>
    <div class="row mb-21">
        <div class="col-12 d-flex align-items-center">
            <span class="fe-empty-container-value">{{
                'fe_precheckin_active_reservation_active_reservation_code'
                    | translate
            }}</span
            >&nbsp;<span
                class="fe-empty-container-title fe-empty-container-title-small fw-bold"
                >{{ reservationDetails?.code }}</span
            >&nbsp;<span class="fe-empty-container-value separator ms-2 me-2"
                >|</span
            >&nbsp;<span class="fe-empty-container-value">{{
                'fe_precheckin_active_reservation_active_reservation_status'
                    | translate
            }}</span
            >&nbsp;<span
                class="fe-empty-container-title fe-empty-container-title-small fw-bold"
                >{{ getStatusText() | translate }}</span
            >
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-6 mb-21 mb-sm-0">
            <span
                class="fe-empty-container-title fe-empty-container-title-small fw-bold d-block mb-21"
                >{{
                    'fe_precheckin_active_reservation_active_reservation_office'
                        | translate
                }}</span
            >
            <div class="fe-empty-container-value">
                {{ reservationDetails?.pickupBranch?.branchName }}
            </div>
            <div class="fe-empty-container-value">
                {{ reservationDetails?.returnBranch?.branchName }}
            </div>
        </div>
        <div class="col-12 col-sm-6">
            <span
                class="fe-empty-container-title fe-empty-container-title-small fw-bold d-block mb-21"
                >{{
                    'fe_precheckin_active_reservation_active_reservation_date'
                        | translate
                }}</span
            >
            <div class="fe-empty-container-subtitle fw-bold">
                {{
                    'fe_precheckin_active_reservation_active_reservation_pickup'
                        | translate
                }}
            </div>
            <div
                class="fe-empty-container-value mb-1 d-flex align-items-center"
            >
                {{
                    reservationDetails?.pickupDate
                        | formatDate: dateFormatProgressBar
                }}
                <!-- <span>
                    <fe-button
                        [btnClass]="'fw-normal p-0 text-tertiary'"
                        [style]="'link'"
                        class="btn-change-hour ms-6 d-flex"
                        (onClick)="onClickChangeHour()"
                        >{{
                            'fe_precheckin_active_reservation_active_reservation_change_hour'
                                | translate
                        }}</fe-button
                    >
                </span> -->
            </div>
            <div class="fe-empty-container-subtitle fw-bold">
                {{
                    'fe_precheckin_active_reservation_active_reservation_return'
                        | translate
                }}
            </div>
            <div class="fe-empty-container-value">
                {{
                    reservationDetails?.returnDate
                        | formatDate: dateFormatProgressBar
                }}
            </div>
        </div>
    </div>
    <hr class="separator" />
    <div class="row">
        <div class="col-auto mb-25">
            <div class="fe-empty-container-title fw-bold">
                {{ reservationDetails?.car?.name }}
            </div>
            <div class="fe-empty-container-value">
                {{ reservationDetails?.car?.model }}
            </div>
            <fe-car-features
                [features]="reservationDetails?.car?.features"
                [color]="'primary'"
                [size]="'small'"
            ></fe-car-features>
        </div>
        <div class="col-auto mb-25">
            <img
                class="h-100 car-size"
                [src]="reservationDetails?.car?.img"
                alt="car vehicle selected"
            />
        </div>
    </div>
</fe-empty-container>
<swal
    #changeHourTemplate
    [showConfirmButton]="true"
    [showCancelButton]="true"
    [confirmButtonText]="
        'fe_precheckin_active_reservation_active_reservation_alert_confirmation'
            | translate
    "
    [cancelButtonText]="
        'fe_precheckin_active_reservation_active_reservation_alert_cancellation'
            | translate
    "
    [customClass]="{ popup: 'custom-swal-popup-cancel' }"
    [showCloseButton]="true"
>
    <div *swalPortal="undefined">
        <div class="title-change-hour fw-bold">
            {{
                'fe_precheckin_active_reservation_active_reservation_alert_title'
                    | translate
            }}
        </div>
        <div class="d-flex justify-content-center w-100">
            <fe-input
                class="w-75"
                #inputStartHour
                [isSelect]="true"
                [id]="'name'"
                [label]="
                    'fe_precheckin_active_reservation_active_reservation_alert_input'
                        | translate
                "
                [appendToSelect]="'body'"
                [items]="startHours"
                [(ngModel)]="selectedHour"
            ></fe-input>
        </div>
    </div>
</swal>
